import {
  Component, OnInit, OnDestroy, HostListener,
  ElementRef, ViewChild, AfterViewInit, NgZone
} from '@angular/core';

@Component({
  selector: 'app-about-gaze',
  templateUrl: './about-gaze.component.html',
  styleUrls: ['./about-gaze.component.scss']
})
export class AboutGazeComponent implements OnInit, AfterViewInit, OnDestroy {

  // ── nav ──────────────────────────────────────────────────────────────────
  scrolled = false;

  // ── hero parallax ────────────────────────────────────────────────────────
  heroImgY    = '0%';
  heroTextY   = '0%';
  heroOpacity = 1;

  // ── carousel (scroll-driven) ─────────────────────────────────────────────
  stripX    = '4vw';
  progressW = '0%';

  // ── sky / timer section ──────────────────────────────────────────────────
  skyBg        = 'linear-gradient(180deg,#f4d58d 0%,#e8a988 35%,#c98f7a 70%,#7a8fa8 100%)';
  orbLeft      = '20%';
  orbTop       = '82%';
  orbOpacity   = 1;
  orbColor     = 'rgb(255,224,120)';
  orbShadow    = '';
  grainX       = 0;
  grainY       = 0;
  displayMinutes = 5;
  sliderPct    = 0;          // 0-100
  dragging     = false;

  // ── testimonials ─────────────────────────────────────────────────────────
  quoteIndex    = 0;
  quoteVisible  = true;
  prevQuoteIndex = 0;

  // ── data ─────────────────────────────────────────────────────────────────
  testimonials = [
    { quote: 'Helps me to relax and focus on just this and nothing else.', author: 'Gracie', location: 'USA' },
    { quote: 'When I need a break from life — aka meditation.',             author: 'Rui',    location: 'China' },
    { quote: 'Allows me to relax and calm down after a long day.',          author: 'David',  location: 'Argentina' },
    { quote: 'Helps me reflect on how big the world really is.',            author: 'Gabby',  location: 'Brazil' },
  ];

  carousel = [
    { img: 'assets/images/gaze-marketing/carousel-chris.webp',         location: 'Chris — Melbourne, Australia',             w: '52vw', h: '52vh' },
    { img: 'assets/images/gaze-marketing/carousel-michael-nyc.webp',   location: 'Michael — New York City, USA',             w: '44vw', h: '46vh' },
    { img: 'assets/images/gaze-marketing/carousel-greg.webp',          location: 'Greg — Nanaimo, British Columbia, Canada', w: '56vw', h: '54vh' },
    { img: 'assets/images/gaze-marketing/carousel-helen.webp',         location: 'Helen — Putaruru, New Zealand',            w: '46vw', h: '48vh' },
    { img: 'assets/images/gaze-marketing/carousel-kathleen.webp',      location: 'Kathleen — Brooklyn, NY, USA',             w: '50vw', h: '54vh' },
    { img: 'assets/images/gaze-marketing/carousel-kate.webp',          location: 'Kate — Jones Island, WA, USA',             w: '42vw', h: '46vh' },
    { img: 'assets/images/gaze-marketing/carousel-elisabeth.webp',     location: 'Elisabeth — Hoboken, New Jersey, USA',     w: '54vw', h: '52vh' },
    { img: 'assets/images/gaze-marketing/carousel-lauren.webp',        location: 'Lauren — Atlantic Highlands, USA',         w: '44vw', h: '48vh' },
    { img: 'assets/images/gaze-marketing/carousel-michael-berlin.webp',location: 'Michael — Berlin, Germany',                w: '48vw', h: '50vh' },
    { img: 'assets/images/gaze-marketing/carousel-nicolas.webp',       location: 'Nicolas — Painswick, United Kingdom',      w: '46vw', h: '46vh' },
  ];

  pressLogos = [
    { src: 'assets/images/gaze-marketing/press1.png',          alt: 'Press',          h: 32 },
    { src: 'assets/images/gaze-marketing/press2.png',          alt: 'BBC',            h: 27 },
    { src: 'assets/images/gaze-marketing/press3.png',          alt: 'Press',          h: 32 },
    { src: 'assets/images/gaze-marketing/press4.png',          alt: 'Press',          h: 32 },
    { src: 'assets/images/gaze-marketing/press-guardian.png',  alt: 'The Guardian',   h: 34 },
    { src: 'assets/images/gaze-marketing/press-vanityfair.png',alt: 'Vanity Fair',    h: 24 },
    { src: 'assets/images/gaze-marketing/press-newyorker.png', alt: 'The New Yorker', h: 32 },
    { src: 'assets/images/gaze-marketing/press-cnn.png',       alt: 'CNN',            h: 24 },
    { src: 'assets/images/gaze-marketing/press-mashable.png',  alt: 'Mashable',       h: 24 },
    { src: 'assets/images/gaze-marketing/press-fastcompany.png',alt:'Fast Company',   h: 24 },
    { src: 'assets/images/gaze-marketing/press-forbes.png',    alt: 'Forbes',         h: 32 },
    { src: 'assets/images/gaze-marketing/press-nyt.png',       alt: 'New York Times', h: 40 },
    { src: 'assets/images/gaze-marketing/press-smithsonian.png',alt:'Smithsonian',    h: 40 },
    { src: 'assets/images/gaze-marketing/press-verge.png',     alt: 'The Verge',      h: 20 },
  ];

  stats = [
    { n: '80+',  label: 'Countries' },
    { n: '12k+', label: 'Windows shared' },
    { n: '∞',    label: 'Quiet moments' },
  ];

  soundAmps = [0.4,0.7,1,0.6,0.9,0.5,1,0.75,0.45,0.85,0.6,1,0.5,0.8,0.4,0.9,0.65,1,0.55,0.75,0.4,0.85,0.6,0.95,0.45,0.7,1,0.5,0.8,0.35];

  timerTicks = [5, 10, 15, 20];

  // ── refs ─────────────────────────────────────────────────────────────────
  @ViewChild('heroSection')   heroSection!:   ElementRef<HTMLElement>;
  @ViewChild('gallerySection')gallerySection!:ElementRef<HTMLElement>;
  @ViewChild('timerSection')  timerSection!:  ElementRef<HTMLElement>;
  @ViewChild('sliderTrack')   sliderTrack!:   ElementRef<HTMLElement>;

  // ── private ──────────────────────────────────────────────────────────────
  private quoteInterval: any;
  private grainInterval: any;
  private raf: number = 0;
  private draggingRef = false;

  constructor(private zone: NgZone) {}

  ngOnInit(): void {
    // rotate quotes with fade transition
    this.quoteInterval = setInterval(() => {
      this.zone.run(() => {
        this.quoteVisible = false;
        setTimeout(() => {
          this.quoteIndex = (this.quoteIndex + 1) % this.testimonials.length;
          this.quoteVisible = true;
        }, 450);
      });
    }, 4500);

    // grain flicker
    this.grainInterval = setInterval(() => {
      this.grainX = Math.floor(Math.random() * 180);
      this.grainY = Math.floor(Math.random() * 180);
    }, 700);
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    clearInterval(this.quoteInterval);
    clearInterval(this.grainInterval);
    cancelAnimationFrame(this.raf);
  }

  // ── scroll handler ───────────────────────────────────────────────────────
  @HostListener('window:scroll')
  onScroll(): void {
    const sy = window.scrollY;
    this.scrolled = sy > 60;
    this._updateHero(sy);
    this._updateCarousel(sy);
    this._updateTimer(sy);
  }

  private _updateHero(sy: number): void {
    if (!this.heroSection) return;
    const el   = this.heroSection.nativeElement;
    const h    = el.offsetHeight;
    const top  = el.offsetTop;
    const prog = Math.max(0, Math.min(1, (sy - top) / h));
    this.heroImgY    = (prog * 28) + '%';
    this.heroTextY   = (prog * 18) + '%';
    this.heroOpacity = Math.max(0, 1 - prog / 0.7);
  }

  private _updateCarousel(sy: number): void {
    if (!this.gallerySection) return;
    const el      = this.gallerySection.nativeElement;
    const top     = el.offsetTop;
    const scrollH = el.offsetHeight - window.innerHeight;   // scrollable budget
    const prog    = Math.max(0, Math.min(1, (sy - top) / scrollH));
    // React: x from "4vw" → "-360vw"  (total travel = 364vw)
    const vw      = window.innerWidth / 100;
    const xPx     = 4 * vw - prog * 364 * vw;
    this.stripX    = xPx + 'px';
    this.progressW = (prog * 100) + '%';
  }

  private _updateTimer(sy: number): void {
    if (!this.timerSection || this.draggingRef) return;
    const el      = this.timerSection.nativeElement;
    const top     = el.offsetTop;
    const scrollH = el.offsetHeight - window.innerHeight;   // scrollable budget
    const prog    = Math.max(0, Math.min(1, (sy - top) / scrollH));
    this._applyTimerProgress(prog);
  }

  // ── sky / timer helpers ──────────────────────────────────────────────────
  private _applyTimerProgress(prog: number): void {
    const phases = [
      { stops: ['#f4d58d','#e8a988','#c98f7a','#7a8fa8'], orb: { x:20, y:82, c:[255,224,120] as [number,number,number], a:1.0 } },
      { stops: ['#a8d4e8','#c8e4ef','#8fadc2','#5b7a94'], orb: { x:50, y: 8, c:[255,252,235] as [number,number,number], a:1.0 } },
      { stops: ['#e8a988','#c1718f','#5b4f72','#20212c'], orb: { x:80, y:80, c:[255,160,90]  as [number,number,number], a:1.0 } },
    ];
    const h2r = (h: string): [number,number,number] => [parseInt(h.slice(1,3),16),parseInt(h.slice(3,5),16),parseInt(h.slice(5,7),16)];
    const li  = (a: number, b: number, t: number) => Math.round(a + (b-a)*t);
    const lc  = (c1: string, c2: string, t: number) => { const [r1,g1,b1]=h2r(c1),[r2,g2,b2]=h2r(c2); return `rgb(${li(r1,r2,t)},${li(g1,g2,t)},${li(b1,b2,t)})`; };
    const ease = (t: number) => t < 0.5 ? 2*t*t : 1 - Math.pow(-2*t+2,2)/2;

    const raw  = Math.min(0.9999, prog) * 2;
    const i    = Math.min(Math.floor(raw), 1);
    const tRaw = raw - i;
    const tCol = ease(tRaw);
    const c = phases[i], n = phases[i+1];

    const s = c.stops.map((stop, k) => lc(stop, n.stops[k], tCol));
    this.skyBg = `linear-gradient(180deg,${s[0]} 0%,${s[1]} 35%,${s[2]} 70%,${s[3]} 100%)`;

    const ox = c.orb.x + (n.orb.x - c.orb.x) * tRaw;
    const oy = c.orb.y + (n.orb.y - c.orb.y) * tRaw;
    const [r1,g1,b1] = c.orb.c, [r2,g2,b2] = n.orb.c;
    const r = li(r1,r2,tCol), g = li(g1,g2,tCol), b = li(b1,b2,tCol);
    this.orbLeft    = ox + '%';
    this.orbTop     = oy + '%';
    this.orbOpacity = c.orb.a + (n.orb.a - c.orb.a) * tCol;
    this.orbColor   = `rgb(${r},${g},${b})`;
    this.orbShadow  = `0 0 18px 8px rgba(${r},${g},${b},0.55),0 0 60px 28px rgba(${r},${g},${b},0.22),0 0 120px 60px rgba(${r},${g},${b},0.08)`;

    if (!this.draggingRef) {
      this.sliderPct     = prog * 100;
      this.displayMinutes = Math.round(prog * 15) + 5;
    }
  }

  // ── slider drag ──────────────────────────────────────────────────────────
  onSliderMouseDown(e: MouseEvent): void {
    e.preventDefault();
    this.draggingRef = true;
    this.dragging    = true;
    this._updateSliderFromX(e.clientX);
    const onMove = (ev: MouseEvent) => this._updateSliderFromX(ev.clientX);
    const onUp   = () => {
      this.draggingRef = false;
      this.dragging    = false;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }

  onSliderTouchStart(e: TouchEvent): void {
    this.draggingRef = true;
    this.dragging    = true;
    this._updateSliderFromX(e.touches[0].clientX);
    const onMove = (ev: TouchEvent) => this._updateSliderFromX(ev.touches[0].clientX);
    const onEnd  = () => {
      this.draggingRef = false;
      this.dragging    = false;
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onEnd);
    };
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onEnd);
  }

  private _updateSliderFromX(clientX: number): void {
    if (!this.sliderTrack) return;
    const rect  = this.sliderTrack.nativeElement.getBoundingClientRect();
    const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    this.sliderPct      = ratio * 100;
    this.displayMinutes = Math.round(ratio * 15) + 5;
  }

  setTickValue(t: number): void {
    const ratio = (t - 5) / 15;
    this.sliderPct      = ratio * 100;
    this.displayMinutes = t;
  }

  // ── quote dots ───────────────────────────────────────────────────────────
  setQuote(i: number): void {
    if (i === this.quoteIndex) return;
    this.quoteVisible = false;
    setTimeout(() => {
      this.quoteIndex  = i;
      this.quoteVisible = true;
    }, 450);
  }

  // ── store buttons ────────────────────────────────────────────────────────
  openAppStore():  void { window.open('https://apps.apple.com/app/id6743534898', '_blank'); }
  openPlayStore(): void { window.open('https://play.google.com/store/apps/', '_blank'); }

  // ── scroll ───────────────────────────────────────────────────────────────
  scrollToDownload(): void {
    const el = document.getElementById('download');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }

  // ── helpers ──────────────────────────────────────────────────────────────
  barDuration(i: number): string { return (1.8 + (i % 7) * 0.3) + 's'; }
  barDelay(i: number):    string { return (i * 0.06) + 's'; }
  barHeight(amp: number): string { return (40 * amp) + 'px'; }
  tickLeft(t: number):    string { return (((t - 5) / 15) * 100) + '%'; }
}
